var req = require.context('./app', true, /\.js$/);
req.keys().forEach((file) => {
   // console.debug(`Loading legacy file ${file}`);
   req(file);
});
